// Vite replaces `import.meta.env.X` at build time. Isolating the read
// here lets Jest mock this module (see jest.config.cjs moduleNameMapper)
// so the feature-flag module compiles under the CommonJS test runner
// (which can't parse `import.meta`).
const raw = import.meta.env['VITE_LAUNCHDARKLY_CLIENT_ID'] as string | undefined;

export const LAUNCHDARKLY_CLIENT_ID: string | undefined = raw === '' ? undefined : raw;
